import 'css-chunksrc/client/scenes/accountCreationConfirmation/form/styles.scss';export default {
  "form": "_form_1lldv_1",
  "input": "_input_1lldv_5",
  "invalidInput": "_invalidInput_1lldv_19"
};